export enum SearchMatchMode {
    Prefix = 'prefix',
    FullText = 'fulltext',
}
